import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    codelist: [],
    updatePosterDialog: false,
    totalCount: 0,
  },
  getters: {
   filterList:state=>state.codelist
  },
  mutations: {
    setcodelist(state, payload) {
      state.codelist = payload;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state,payload){
      state.totalCount=payload
    }
  },
  actions: {
  async  getlist({commit},data){
      const res=await api.getList(data)
      commit("setcodelist", res.data.list);
      commit('setTotalCount',res.data.totalCount)
      return res 
    },
 
    async delOne({ commit }, id) {
      const res = await api.delOne(id);
      return res;
    },
    async addOne({ commit }, id) {
      const res = await api.addOne(id);
      return res;
    },
  async  updateOne({commit},{id,data}){
      const res=await api.updateCode(id,data)
      return res
    }

  },
};

appStore.registerModule("config-i18n", store);
